import React from 'react'
import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Col, Form, Portlet, Row } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import { MotivosBajaActivoConstant } from 'constants/index'

import * as ActivosFijosService from 'services/activosFijos.service'
import * as ActivosFijosBajasService from 'services/activosFijosBajas.service'

const portletBreadcrumbs = [{ name: 'Activos Fijos' }, { name: 'Bajas' }, { name: 'Nueva' }]

const initialValues = {
  _idActivoFijo: '',
  codigoActivoFijo: '',
  descripcionActivoFijo: '',
  motivo: '',
  descripcion: '',
  observaciones: '',
  valorEnLibros: 0,
  valorRecupero: 0,
  fechaSolicitud: new Date().toLocaleDateString('es-PE')
}

const NuevoPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)
  const [activosFijos, setActivosFijos] = React.useState([])

  React.useEffect(() => {
    ActivosFijosService.getSelect({ cuenta: '' })
      .then(({ data }) => setActivosFijos(data || []))
      .catch(() => setActivosFijos([]))
  }, [])

  const handleSubmit = async (values, actions) => {
    actions.setSubmitting(true)
    try {
      const { data } = await ActivosFijosBajasService.nuevo(values)
      __zariContext.snack('success', `Baja ${data.codigo} creada!`)
      history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_BAJAS_EDITAR}/${data._id}`)
    } catch (e) {
      __zariContext.snack('error', e?.data?.error || 'Error al crear baja')
    } finally {
      actions.setSubmitting(false)
    }
  }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ values, handleChange, setFieldValue, handleSubmit, isSubmitting }) => (
        <Portlet>
          <Portlet.Header
            title='Nueva Baja de Activo'
            breadcrumbs={portletBreadcrumbs}
            buttons={[
              { name: 'Guardar', onClick: handleSubmit, disabled: isSubmitting },
              { name: 'Cancelar', onClick: () => history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_BAJAS_LISTA}`) }
            ]}
          />
          <Portlet.Body>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label text='ACTIVO FIJO' md={12} />
                  <Col md={12}>
                    <Form.Select
                      name='_idActivoFijo'
                      value={values._idActivoFijo}
                      onChange={e => {
                        const selected = activosFijos.find(x => x._id === e.target.value) || {}
                        setFieldValue('_idActivoFijo', e.target.value)
                        setFieldValue('codigoActivoFijo', selected.codigo || '')
                        setFieldValue('descripcionActivoFijo', selected.nombre || selected.descripcion || '')
                      }}
                    >
                      <option value=''>--SELECCIONAR--</option>
                      {activosFijos.map(x => (
                        <option key={x._id} value={x._id}>
                          {`${x.codigo || ''} - ${x.nombre || x.descripcion || ''}`}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label text='FECHA SOLICITUD' md={12} />
                  <Col md={12}>
                    <Form.InputDate name='fechaSolicitud' value={values.fechaSolicitud} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label text='MOTIVO' md={12} />
                  <Col md={12}>
                    <Form.Select name='motivo' value={values.motivo} onChange={handleChange}>
                      <option value=''>--SELECCIONAR--</option>
                      {MotivosBajaActivoConstant.__array.map(x => (
                        <option key={x.id} value={x.id}>
                          {x.nombre}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={8}>
                <Form.Group>
                  <Form.Label text='DESCRIPCIÓN' md={12} />
                  <Col md={12}>
                    <Form.InputText name='descripcion' value={values.descripcion} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='VALOR LIBROS' md={12} />
                  <Col md={12}>
                    <Form.InputNumber name='valorEnLibros' value={values.valorEnLibros} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label text='VALOR RECUPERO' md={12} />
                  <Col md={12}>
                    <Form.InputNumber name='valorRecupero' value={values.valorRecupero} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Form.Group>
                  <Form.Label text='OBSERVACIONES' md={12} />
                  <Col md={12}>
                    <Form.InputText name='observaciones' value={values.observaciones} onChange={handleChange} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Portlet.Body>
        </Portlet>
      )}
    </Formik>
  )
}

export default React.memo(NuevoPage)
